import querystring from 'querystring'

import Cookies from 'js-cookie'
import snakeCase from 'lodash/snakeCase'

import { IDENTIFY, LINKCLICK, PAGE, TRACK } from '../constants'
import { AnalyticsHandlers } from '~/lib/analytics/handlers/types'
import MunchkinApi from '~/lib/apis/MunchkinApi'

export const MUNCHKIN_HASH_COOKIE = '_fictiv_munchkin_hash'

export default function (munchkinApi: MunchkinApi): AnalyticsHandlers {
    munchkinApi.init()

    return {
        [TRACK]({ event, properties }) {
            const action = snakeCase(event)
            const params = querystring.stringify(properties)
            const href = `/actions/${action}?${params}`

            munchkinApi.clickLink(href)
        },
        [LINKCLICK]({ href }) {
            munchkinApi.clickLink(href || '')
        },
        [PAGE]({ properties }) {
            munchkinApi.visitWebPage(properties.path)
        },
        [IDENTIFY](payload) {
            if (payload.traits?.munchkinHash) {
                Cookies.set(MUNCHKIN_HASH_COOKIE, payload.traits?.munchkinHash)
            }

            munchkinApi.associateLead(payload.traits)
        },
    }
}
